export type UseTimer = {
  pause: () => void;
  start: () => void;
  stop: () => void;
  resume: () => void;
  reset: () => void;
  timeElapsed: Readonly<Ref<number>>;
  timeElapsedInSeconds: ComputedRef<number>;
  setTimeElapsed: (timeInSecs: number) => void;
};
export const useTimer = (): UseTimer => {
  const timeElapsed = ref<number>(0);
  const setTimeElapsed = (timeInSecs: number) => {
    timeElapsed.value = timeInSecs * 1000;
  };
  const { pause, resume } = useRafFn(
    ({ delta }) => {
      timeElapsed.value += delta;
    },
    { immediate: false }
  );
  const start = () => {
    resume();
  };
  const reset = () => {
    timeElapsed.value = 0;
  };
  const stop = () => {
    pause();
    reset();
  };
  const timeElapsedInSeconds = computed(() =>
    Math.floor(timeElapsed.value / 1000)
  );
  return {
    timeElapsed: readonly(timeElapsed),
    timeElapsedInSeconds,
    setTimeElapsed,
    start,
    pause,
    stop,
    resume,
    reset,
  };
};
